/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import HeadTittle from "../../../../../../../components/HeadTittle";
import {permissionObj} from "../../../../../../../Helpers/permission";
import routes from "../../../../../../../Routes/routes";
import React from "react";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import {
    InfoChip
} from "../../../../../../../components/buttons/IconButtons";
import {STATUS_MODEL} from "../../../../../../../enums/statusEnum";
import CustomCard from "../../../../../../../components/CustomCard";
import {getDateFormat} from "../../../../../../../Apis/functions";
import CustomUserChip from "../../../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../../../Helpers/PositionModel";
import SubmissionHistoryDetailsApp from "../Functionality/SubmissionHistoryDetailsApp";
import {mapRequestedBatchRows, SUBMISSION_REQUEST_CARD_MODEL} from "../../Request/Model/Model";
import RequestedDetailsSection from "../../Request/SubComponents/RequestedDetailsSection";
import RequestedBatchOverviewTable from "../../Request/SubComponents/RequestedBatchOverviewTable";

const SubmissionHistoryDetails = () => {
    const {
        t,
        navigate,
        DEV,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        goBack,
        evidence,
        showBadge,
        isAttendanceSupervisor
    } = SubmissionHistoryDetailsApp();

    if (!DEV &&
        !permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_HISTORY_READ) &&
        !isAttendanceSupervisor //Used for attendance department supervisor, for can manage attendees, slice loaded in login action
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'details'} onBack={goBack}/>

            <DivContainerBody>
                <div className={"mb-4"}>
                    {[STATUS_MODEL.PENDING_REVIEW, STATUS_MODEL.CHANGES_REQUESTED].includes(item?.approvalStatusId) &&
                        <CustomUserChip
                            className="mt-0 chip-error-code-150-100 justify-content-start d-flex mb-4 w-100"
                            name={t('request_has_expired_it_is_not_possible_complete_approval')}
                            Icon={InfoChip}
                            showAvatar={true}
                            classNameIcon={"icon-color-error-code-700"}
                            variant="large"
                            iconPosition={POSITION_MODEL.LEFT}
                        />
                    }

                    { showBadge &&
                    (() => {
                        const data = SUBMISSION_REQUEST_CARD_MODEL.getById(item?.approvalStatusId);
                        return (
                            <CustomCard
                                classes={`border-radius-8px`}
                                classCard={`border-radius-8px ${data.classCard}`}
                                children={
                                    <div className={`d-flex flex-column justify-content-start gap-3`}>
                                        <div className={"gap-2"}>
                                            <p className={`ibl-font-w-600 fs-14px ${data?.fontColor}`}>
                                                {t(data?.title)}
                                            </p>
                                            {item?.reason && (
                                                <p className={"fs-12px ibl-font-w-600 font-color-shades-800"}>
                                                    {item?.reason}
                                                </p>
                                            )}
                                        </div>
                                        <p className={"fs-12px font-color-shades-600"}>
                                            {t(data?.byTrans)} {item?.approverUser} ·{" "}
                                            {item?.decisionDate !== null ? getDateFormat(item?.decisionDate) : ""}
                                        </p>
                                    </div>
                                }
                            />
                        );
                    })()
                    }
                </div>
                <div className='row px-0'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                         ref={containerCardRef}>
                        <RequestedDetailsSection
                            item={item}
                            evidence={evidence}
                            contentCardRef={contentCardRef}
                            statusId={item?.approvalStatusId === STATUS_MODEL.PENDING_REVIEW ? STATUS_MODEL.PENDING : item?.approvalStatusId}
                        />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                        <RequestedBatchOverviewTable
                            contentTableRef={contentTableRef}
                            attendancePeriod={{startDate: item?.periodStartDate, endDate: item?.periodEndDate}}
                            statusId={item?.approvalStatusId === STATUS_MODEL.PENDING_REVIEW ? STATUS_MODEL.PENDING : item?.approvalStatusId }
                            objectItems={mapRequestedBatchRows(item?.objectItems) || []}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default SubmissionHistoryDetails;
